/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

export const FcsPermissionPickupDashboard = {
  permission_pickup_dashboard_monitoring_enable: new FcsFlag.Flag(false),
  permission_pickup_dashboard_manage_area_enable: new FcsFlag.Flag(false)
};

export function initFlagsPermissionPickupDashboard() {
  FcsFlag.register("flagPickupDashboard", FcsPermissionPickupDashboard);
}
